





























































import AmountTopUp from '@components/common/amount-top-up.vue';
import InputField from '@components/common/input-field.vue';
import { FormAttribute } from '@enums';
import topupService from '@services/topup-service';
import { normalizePhone } from '@services/utils';
import { AmountTopUpInstance } from '@types';
import Vue, { VueConstructor } from 'vue';

export default (Vue as VueConstructor<Vue & {
	$refs: {
		topUp: AmountTopUpInstance
	};
}>).extend({
	name: 'PageTopUp',
	components: {
		InputField,
		AmountTopUp,
	},
	data() {
		return {
			formData: {
				phone: '',
				email: '',
			},
			FormAttribute,
		};
	},
	methods: {
		sendForm(): void {
			const data = {
				amount: this.$refs.topUp.amount,
				email: this.formData.email,
				msisdn: normalizePhone(this.formData.phone),
			};

			topupService.sendTopUp(data);
		},
	},
});
